<template>
	<div v-if="listNotFound" class="center-container">
			<h1>Page not found</h1>
			<p>Sorry, but there is no person with that ID in our database. If this problem persists, contact <a href="mailto:support@bookplate.co">support@bookplate.co</a>.</p>
			<h2><router-link to='/'>Return Home</router-link></h2>
	</div>
	<list 
		v-else
		v-bind:title="'Liked'" 
		v-bind:readerName="readerName"
		v-bind:readerId="readerId"
		v-bind:readerProfileColour="readerProfileColour"
	>
		<a class="loading cover" v-if="readerProfileColour == '' || readerProfileColour == 'undefined' || readerProfileColour == null"></a>
		<a class="loading cover" v-if="readerProfileColour == '' || readerProfileColour == 'undefined' || readerProfileColour == null"></a>
		<a class="loading cover" v-if="readerProfileColour == '' || readerProfileColour == 'undefined' || readerProfileColour == null"></a>
		<a class="loading cover" v-if="readerProfileColour == '' || readerProfileColour == 'undefined' || readerProfileColour == null"></a>
		<a class="loading cover" v-if="readerProfileColour == '' || readerProfileColour == 'undefined' || readerProfileColour == null"></a>
		<p v-else-if="bookList == '' || bookList == 'undefined' || bookList == null">There are no books in this list.</p>
		<router-link v-else v-for="book in bookList" :key="book.title" class="cover" :to="{path:'/book/' + book.book_id}" v-bind:style="{ backgroundImage: 'url(' + book.cover_url + ')' }">"{{ book.title }}" book cover</router-link>
	</list>
</template>

<script>
	import List from '../../layout/List.vue'

	export default 
	{
		components: 
		{
			List
		},
		created () 
		{
			document.title = "Bookplate";
		},
		data () 
		{
			return {
				info: "",
				notFound: false
			}
		},
		mounted () 
		{
			try 
			{
				let vue = this;

				fetch('https://api.bookplate.co/profile/' + this.readerId + '/liked',
				{
					credentials: 'include'
				})
				.then(function(response)
				{
					if(response.status == 404)
					{
						vue.notFound = true;
						return "";
					}

					return response.json();
				})
				.then(json => this.info = json)
				.then(function (json) 
				{
					if(vue.notFound)
					{
						document.title = "Page not found | Bookplate";
					}
					else
					{
						document.title = json.name + "'s Liked Books | Bookplate";
					}
				})
			}
			catch(e)
			{
				this.$alert("Something went wrong. Please try again in a moment, or contact support@bookplate.co. Error:" + e, "An error occured");
			}
		},
		computed: 
		{
			listNotFound: function()
			{
				return this.notFound;
			},
			readerId: function()
			{
				return this.$route.params.id;
			},
			readerName: function() 
			{
				return this.info.name;
			},
			readerProfileColour: function() 
			{
				return this.info.profile_color;
			},
			bookList: function()
			{
				return this.info.book_list;
			}
		}
	}
</script>